export default {
    namespaced: true,

    state() {
        return {
            currentCountryCode: '',
            inebriationWarningShowed: false,
        };
    },
    getters: {
        code: state => state.currentCountryCode,
        inebriationWarningShowed: state => state.inebriationWarningShowed,
    },
    mutations: {
        setCurrentCountryCode(state, code) {
            state.currentCountryCode = code;
        },
        setInebriationWarningShowed(state, showed) {
            state.inebriationWarningShowed = showed;
        }
    },
    actions: {
        async changeCountryCode({ commit }, code) {
            commit('setCurrentCountryCode', code);
        },
    },
};
